import { createSlotRecipe } from './runtime';

const switchRecipeConfig = {"name":"switchRecipe","slots":["root","label","control","thumb"],"defaultVariants":{"size":"md"},"variantMap":{"size":["lg","md","sm"]}}

export const switchRecipe = /* @__PURE__ */ createSlotRecipe(switchRecipeConfig)